import React, { useState, useEffect } from 'react';
import {
  Box,
  Tooltip,
} from '@mui/material';
import {
  Chat as ChatIcon,
} from '@mui/icons-material';

interface NotificationBadgeProps {
  ticketId: number;
  unreadCount: number;
  onMarkAsRead: (ticketId: number) => void;
  onOpenMessages: (ticketId: number) => void; // ✅ ticketId bekliyor
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  ticketId,
  unreadCount,
  onMarkAsRead,
  onOpenMessages,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (unreadCount > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [unreadCount]);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    if (unreadCount > 0) {
      onMarkAsRead(ticketId);
    }
    // ✅ Sadece ticketId gönder
    onOpenMessages(ticketId);
  };

  if (unreadCount === 0) {
    return (
      <Tooltip title="Okunmamış mesaj yok">
        <Box
          sx={{
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            color: 'grey.400',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'grey.50',
              color: 'grey.600',
            },
            transition: 'all 0.2s ease',
          }}
          onClick={handleClick}
        >
          <ChatIcon sx={{ fontSize: '16px' }} />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={`${unreadCount} okunmamış mesaj - Tıklayarak okundu olarak işaretle`}>
      <Box
        sx={{
          position: 'relative',
          width: '28px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '6px',
          backgroundColor: 'primary.50',
          color: 'primary.main',
          cursor: 'pointer',
          animation: isAnimating ? 'gentlePulse 2s infinite' : 'none',
          '&:hover': {
            backgroundColor: 'primary.100',
            color: 'primary.dark',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 6px rgba(25, 118, 210, 0.15)',
          },
          transition: 'all 0.2s ease',
          '@keyframes gentlePulse': {
            '0%': {
              transform: 'scale(1)',
              boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.3)'
            },
            '50%': {
              transform: 'scale(1.05)',
              boxShadow: '0 0 0 5px rgba(25, 118, 210, 0)'
            },
            '100%': {
              transform: 'scale(1)',
              boxShadow: '0 0 0 0 rgba(25, 118, 210, 0)'
            }
          }
        }}
        onClick={handleClick}
      >
        <ChatIcon sx={{ fontSize: '16px' }} />
        
        <Box
          sx={{
            position: 'absolute',
            top: '-3px',
            right: '-3px',
            minWidth: '14px',
            height: '14px',
            borderRadius: '7px',
            backgroundColor: 'error.main',
            color: 'white',
            fontSize: '0.5rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 1px',
            boxShadow: '0 1px 3px rgba(211, 47, 47, 0.3)',
            lineHeight: 1,
          }}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </Box>
      </Box>
    </Tooltip>
  );
};